import { NgModule } from "@angular/core";
import { RaskCommonModule } from "~app/common/rask-common.module";
import { OvervakningComponent } from "./overvakning.component";
import { SchemalaggningDetailsComponent } from "./schemalaggning-details/schemalaggning-details.component";
import { SchemalaggningListComponent } from "./schemalaggning-list/schemalaggning-list.component";
import { SchemalaggningService } from "./schemalaggning.service";

@NgModule({
    imports: [
        RaskCommonModule,
        OvervakningComponent,
        SchemalaggningListComponent,
        SchemalaggningDetailsComponent
    ],
    providers: [SchemalaggningService]
})
export class OvervakningModule { }
